// src/api.js
// const BASE_URL = "http://192.168.0.103:8080"; 
const BASE_URL = "http://localhost:8080";

export default BASE_URL;
